import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import DataCard from './DataCard';

export default function DetailsCard({ title, sx, label, fullWidth, data }) {
  // console.log({ title, label, data });

  return (
    <Stack
      width={{ xs: '100%', md: fullWidth ? '100%' : 450 }}
      maxWidth={'100%'}
      gap={2}
      sx={{
        bgcolor: 'white',
        p: 2,
        borderRadius: 3,
        ...sx,
      }}
    >
      <Typography variant="h6">{title}</Typography>
      <Divider />
      {Array.isArray(data)
        ? data.map((d) =>
            label?.map((e, i) =>
              Array.isArray(e) ? (
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'} key={i}>
                  {e?.map((v, x) => (
                    <DataCard label={v.label} obKey={v.key} data={d} key={x} Icon={v?.icon} />
                  ))}
                </Box>
              ) : (
                <DataCard label={e.label} obKey={e.key} data={d} key={i} Icon={e?.icon} />
              )
            )
          )
        : label?.map((e, i) =>
            Array.isArray(e) ? (
              <Box display={'flex'} justifyContent={'space-between'} width={'100%'} key={i}>
                {e?.map((v, x) => (
                  <DataCard label={v.label} obKey={v.key} data={data} key={x} Icon={v?.icon} />
                ))}
              </Box>
            ) : (
              <DataCard label={e.label} obKey={e.key} data={data} key={i} Icon={e?.icon} />
            )
          )}
    </Stack>
  );
}
